export default {
  total: "Total",
  view: 'Voir',
  save: 'Enregistrer',
  cancel: 'Annuler',
  delete: 'Supprimer',
  edit: 'Modifier',
  add: 'Ajouter',
  close: 'Fermer',
  confirm: 'Confirmer',
  yes: 'Oui',
  no: 'Non',
  paid: 'Payé',
  unpaid: 'Non payé',
  editor: "Éditeur",
  viewer: "Invité",
  loading: 'Chargement...',
  error: 'Erreur',
  success: 'Succès',
  warning: 'Attention',
  info: 'Information',
  search: 'Rechercher',
  filter: 'Filtrer',
  sort: 'Trier',
  export: 'Exporter',
  import: 'Importer',
  download: 'Télécharger',
  upload: 'Téléverser',
  print: 'Imprimer',
  share: 'Partager',
  copy: 'Copier',
  paste: 'Coller',
  cut: 'Couper',
  undo: 'Annuler',
  redo: 'Rétablir',
  refresh: 'Actualiser',
  back: 'Retour',
  next: 'Suivant',
  previous: 'Précédent',
  first: 'Premier',
  last: 'Dernier',
  all: 'Tous',
  none: 'Aucun',
  select: 'Sélectionner',
  deselect: 'Désélectionner',
  clear: 'Effacer',
  reset: 'Réinitialiser',
  apply: 'Appliquer',
  submit: 'Soumettre',
  send: 'Envoyer',
  receive: 'Recevoir',
  create: 'Créer',
  update: 'Mettre à jour',
  remove: 'Supprimer',
  duplicate: 'Dupliquer',
  move: 'Déplacer',
  upgrade: 'Mettre à niveau',
  details: 'Détails',
  more: "Plus",
  less: "Moins",
  show: "Afficher",
  hide: "Masquer",
  actions: {
    _self: "Actions",
    add: "Ajouter",
    addLong: "Ajouter un nouvel élément",
    importGuests: "Importer des invités",
    share: "Partager",
    useExample: "Utiliser un exemple",
    addEvent: "Ajouter un événement",
    addExamples: "Ajouter des exemples",
    addingExamples: "Ajout des exemples...",
    edit: "Modifier",
    delete: "Supprimer",
    cancel: "Annuler",
    save: "Enregistrer"
  },
  noResults: 'Aucun résultat trouvé',
  pagination: {
    showing: 'Affichage de {{from}} à {{to}} sur {{total}} éléments'
  },
  time: "Heure",
  title: "Titre",
  category: "Catégorie",
  description: "Description",
  continue: "Continuer",
  required: "Requis",
  optional: "Optionnel",
  or: "ou",
  and: "et",
  selectAll: "Tout sélectionner",
  deselectAll: "Tout désélectionner",
  content: "Contenu",
  today: "Aujourd'hui",
  yesterday: "Hier",
  saving: "Enregistrement...",
  viewAll: "Tout voir",
  currentEvent: "Événement actuel",

  // New additions
  disconnect: "Déconnexion",
  sending: "Envoi en cours...",
  verified: "Vérifié",
  importGuests: "Importer des invités",

  status: {
    to_contact: "À contacter",
    contacted: "Contacté",
    meeting_scheduled: "Rendez-vous programmé",
    quote_received: "Devis reçu",
    hired: "Engagé",
    deposit_paid: "Acompte payé",
    completed: "Terminé",
    cancelled: "Annulé",
    pending: "En attente",
    confirmed: "Confirmé",
    declined: "Refusé",
    accepted: "Accepté",
    inProgress: "En cours",
    paid: "Payé",
    unpaid: "Non payé",
    overdue: "En retard",
    scheduled: "Prévu",
    done: "Fait",
    todo: "À faire",
    researching: "Recherche"
  },

  categories: {
    other: "Autre",
    venue: "Lieu",
    catering: "Traiteur",
    photography: "Photographie",
    music: "Musique",
    decoration: "Décoration",
    flowers: "Fleurs",
    attire: "Tenue",
    jewelry: "Bijoux",
    transport: "Transport",
    lodging: "Hébergement",
    ceremony: "Cérémonie",
    reception: "Réception",
    videography: "Vidéographie",
    florist: "Fleuriste",
    cake: "Gâteau",
    dress: "Robe",
    suit: "Costume",
    hair_makeup: "Coiffure & Maquillage",
    beauty: "Beauté"
  },

  pwa: {
    offlineReady: 'App prête pour une utilisation hors ligne',
    newContent: 'Nouveau contenu disponible, cliquez pour mettre à jour.',
    reload: 'Rafraîchir'
  },

  validation: {
    required: {
      firstName: "Le prénom est requis",
      lastName: "Le nom est requis",
      email: "L'email est requis"
    },
    invalid: {
      email: "L'email est invalide"
    }
  },

  empty: {
    title: "Aucune donnée",
    description: "Il n'y a rien à afficher pour le moment."
  },

  errors: {
    submit: "Erreur lors de la soumission",
    loadGuests: "Erreur lors du chargement des invités",
    updateGuest: "Erreur lors de la mise à jour de l'invité",
    socialLoginFailed: "La connexion sociale a échoué",
    userOrWeddingNotFound: "Utilisateur ou mariage introuvable",
    googleSignIn: "Erreur de connexion Google",
    loadVendors: "Erreur lors du chargement des prestataires",
    addVendor: "Erreur lors de l'ajout du prestataire",
    updateVendor: "Erreur lors de la mise à jour du prestataire",
    deleteVendor: "Erreur lors de la suppression du prestataire",
    saveSeatingPlan: "Erreur lors de l'enregistrement du plan de table",
    generateSeatingPlan: "Erreur lors de la génération du plan de table"
  },

  columns: {
    name: "Nom",
    status: "Statut",
    category: "Catégorie",
    actions: "Actions",
    plusOne: "+1",
    children: "Enfants"
  },

  confirmDialog: {
    delete: "Êtes-vous sûr de vouloir supprimer cet élément ?",
    budgetRemoval: {
      title: "Supprimer le budget",
      message: "Voulez-vous vraiment supprimer ce budget ?",
      confirm: "Supprimer",
      cancel: "Annuler"
    }
  },

  deleteConfirmation: {
    title: "Supprimer",
    description: "Cette action est irréversible.",
    confirmTitle: "Confirmer la suppression",
    confirmDescription: "Êtes-vous sûr de vouloir supprimer cet élément ?",
    confirmButton: "Supprimer"
  },

  sortOptions: {
    title: "Trier par"
  },

  sharing: {
    title: "Partage",
    share: "Partager",
    accessLevel: "Niveau d'accès",
    accessCode: "Code d'accès",
    readOnly: "Lecture seule",
    edit: "Modification",
    copy: "Copier le lien",
    copied: "Lien copié !",
    emailPlaceholder: "exemple@email.com",
    namePlaceholder: "Nom du destinataire",
    messagePlaceholder: "Ajouter un message personnel...",
    recipientEmail: "Email du destinataire",
    recipientName: "Nom du destinataire",
    message: "Message",
    defaultMessage: "Je t'invite à collaborer sur mon mariage !",
    invitationCreated: "Invitation créée avec succès",
    success: "Partagé avec succès"
  }
};
